/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { setCurrentPage } from '../../store/Document/documentActions';
import './style.scoped.scss';
import {
  //FaAngleDown,
  FaArrowLeft,
  FaArrowRight,
  //FaAngleUp,
  FaPlusCircle,
  FaMinusCircle,
  FaBookmark,
} from 'react-icons/fa';
import $ from 'jquery';
import {
  // toggleFadeMainContent,
  pageHasContent,
  setElementHeights,
  ROUTES,
  notification,
  USER,
} from '../../assets/constants/strings';
import { Link } from 'react-router-dom';
import { UpdateUserUsage } from '../../store/Paddle/paddleActions';

const LeftNav = ({
  navigation,
  setCurrentPage,
  document: currentDocument,
  currentPage,
  handlePageChange,
  contentType,
  isPreview,
  bookmarks,
  user,
  UpdateUserUsage,
}) => {
  const [leftNavSass, setLeftNavSass] = useState('3 expanded');
  const [isLeftNavVisible, setIsLeftNavVisible] = useState(true);
  const [selectedArrow, setSelectedArrow] = useState('');

  useEffect(() => {
    // if we are in small screen mode, hide navigation upon opening
    toggleVisibility(window.innerWidth < 950);

    // UpdateUserUsage(USER.USAGE.PAGEVIEWS);
  }, []);

  useEffect(() => {
    // if it changes to comparison, we want to hide it
    if (window.innerWidth > 950) {
      if (contentType === 'Comparison' || contentType === 'Search')
        toggleVisibility(true);
      else toggleVisibility(false);
    } else toggleVisibility(true);

    if (contentType === 'Summary' || contentType === 'Version')
      toggleVisibility(true);
  }, [contentType]);

  useEffect(() => {
    const pageTitleMargin = document.getElementById('pageTitle');

    if (pageTitleMargin) {
      if (isLeftNavVisible) {
        //document title margin
        pageTitleMargin.style.marginLeft = '25%';

        if (currentPage.parentId)
          $(`#wf-collapse-${currentPage.parentId}`).collapse('show');
      } else {
        //document title margin
        pageTitleMargin.style.marginLeft = '4rem';
      }
    }
    if (currentPage.parentId) {
      setSelectedArrow(currentPage.parentId);
    }

    setElementHeights();
  }, [isLeftNavVisible]);

  useEffect(() => {
    // if we are in small screen mode, hide navigation upon opening
    toggleVisibility(window.innerWidth < 950);

    setLeftNavSass('3 expanded');
    setIsLeftNavVisible(true);
    // setSelectedArrow('');

    if (currentPage.parentId) {
      setSelectedArrow(currentPage.parentId);
      $(`#wf-collapse-${currentPage.parentId}`).collapse('show');
    } else setSelectedArrow('');

    if (user.remainingPageViews <= 0) {
      return notification(
        'info',
        'You have reached your amount of pages view for the current period.'
      );
    } else UpdateUserUsage(USER.USAGE.PAGEVIEWS);
  }, [currentDocument]);

  useEffect(() => {
    // hide nav if we select another page
    window.innerWidth < 950 && toggleVisibility(true);

    if (currentPage.parentId) {
      setSelectedArrow(currentPage.parentId);
    }
  }, [currentPage]);

  //#region leftnav specific

  const handleSetPage = (selectedItem, hasContent) => {
    if (user.remainingPageViews <= 0) {
      return notification(
        'info',
        'You have reached your amount of pages view for the current period.'
      );
    } else if (hasContent) {
      UpdateUserUsage(USER.USAGE.PAGEVIEWS);
      const page = currentDocument.pages.filter(
        (d) => d.id === selectedItem.id
      )[0];
      setCurrentPage(page, currentDocument.pages);
      // if it is a parent page
      if (selectedItem.children && selectedItem.children.length > 0) {
        // uncollapse bootstrap
        $(`#wf-collapse-${selectedItem.id}`).collapse('show');
        // if we are not selecting the current page again
        if (selectedItem.id !== selectedArrow)
          handleArrowClick(selectedItem.id);
      }
    }
    // no content and no children
    else if (!hasContent && selectedItem.children.length < 1) {
      const page = currentDocument.pages.filter(
        (d) => d.id === selectedItem.id
      )[0];
      setCurrentPage(page, currentDocument.pages);
      UpdateUserUsage(USER.USAGE.PAGEVIEWS);
    }
    // no content but has children
    else {
      // expand it
      $(`#wf-collapse-${selectedItem.id}`).collapse('show');
      if (selectedItem.id !== selectedArrow) handleArrowClick(selectedItem.id);

      // point to first child of this page
      const firstChild = selectedItem.children[0];
      const page = currentDocument.pages.filter(
        (d) => d.id === firstChild.id
      )[0];
      setCurrentPage(page, currentDocument.pages);
      UpdateUserUsage(USER.USAGE.PAGEVIEWS);
    }
    handlePageChange('main');
    $('#main-content').scrollTop(0);
  };

  const renderActiveClasses = (navItem) => {
    if (currentPage.id === navItem.id) {
      return ' active';
    }
    return '';
  };

  const toggleVisibility = (currentBool) => {
    currentBool === true
      ? setLeftNavSass('0 collapsed')
      : setLeftNavSass('3 expanded');

    // window.innerWidth < 950 && toggleFadeMainContent(currentBool);

    setIsLeftNavVisible(!currentBool);
    setSelectedArrow('');
  };

  const handleArrowClick = (id) => {
    $(`#wf-collapse-${id}`).collapse('toggle');
    // to check if the user us toggling
    const currentPage = selectedArrow;
    currentPage !== id ? setSelectedArrow(id) : setSelectedArrow('');
  };

  const renderLeftNavIcon = (item) => {
    if (item.children && item.children.length > 0) {
      return item.id === selectedArrow ? (
        <FaMinusCircle
          title={`Collapse ${item.children.length} item${
            item.children.length === 1 ? '' : 's'
          }`}
          className='left-nav__container__item__icon'
          onClick={() => handleArrowClick(item.id)}
        />
      ) : (
        <FaPlusCircle
          title={`Expand ${item.children.length} item${
            item.children.length === 1 ? '' : 's'
          }`}
          className='left-nav__container__item__icon'
          onClick={() => handleArrowClick(item.id)}
        />
      );
    }
    return;
  };

  //#endregion

  const defineReference = (item) => {
    const hasContent = pageHasContent(item.content);
    // if it has content or if it doesnt have and also doesnt have children
    if (
      hasContent ||
      (!hasContent && item.children && item.children.length < 1)
    ) {
      return isPreview
        ? ROUTES.PREVIEW(currentDocument.slug, item.slug)
        : ROUTES.DOCUMENT(currentDocument.slug, item.slug);
    } else if (item.children && item.children.length > 0) {
      return isPreview
        ? ROUTES.PREVIEW(currentDocument.slug, item.children[0].slug)
        : ROUTES.DOCUMENT(currentDocument.slug, item.children[0].slug);
      // logic to fix empty h3s
    } else return ROUTES.DOCUMENT(currentDocument.slug, item.slug);
  };

  const isBookmark = (slug) => {
    try {
      return (
        // user has permission to access bookmarks
        user &&
          user.restriction <= 1 &&
          // this page is bookmarked
          bookmarks &&
          bookmarks.some(
            (bookmark) =>
              bookmark.page === slug &&
              bookmark.document === currentDocument.slug
          ) ? (
          <FaBookmark
            className='left-nav__bookmark'
            title='This section is bookmarked'
          />
        ) : null
      );
    } catch (e) {
      console.log('could not determine if page is a bookmark', e);
      return null;
    }
  };

  return (
    // will toggle position based on screen size
    <div id='left-nav' className={'col-sm-' + leftNavSass}>
      <div id='left-inner-wrapper'>
        {isLeftNavVisible ? (
          <div className='wf-left hide'>
            <FaArrowLeft
              title='Hide Left Navigation'
              className='arrow-container__arrow'
              onClick={() => toggleVisibility(isLeftNavVisible)}
            />
          </div>
        ) : (
          <div className='wf-left show'>
            <FaArrowRight
              title='Show Left Navigation'
              className='arrow-container__arrow'
              onClick={() => toggleVisibility(isLeftNavVisible)}
            />
          </div>
        )}
        <div className='left-nav' id='left-nav-items'>
          {isLeftNavVisible ? (
            <div className='w-100 accordion' id='H1Group'>
              <ul className='navbar-nav p-0'>
                {navigation.map((H1, i) => {
                  const H1HasContent = pageHasContent(H1.content);
                  const H1HasChildren = H1.children.length > 0;
                  return (
                    <li
                      key={H1.id}
                      id={`wf-H1-${H1.id}`}
                      className='left-nav__container'
                    >
                      <div className='left-nav__container__item'>
                        <Link
                          to={defineReference(H1)}
                          onClick={() => handleSetPage(H1, H1HasContent)}
                          className={`left-nav__container__item__link${renderActiveClasses(
                            H1
                          )}`}
                        >
                          {isBookmark(H1.slug)}
                          {H1.title}
                        </Link>
                        {renderLeftNavIcon(H1)}
                      </div>
                      {/* only render the collapse structure if we actually need it */}
                      {H1HasChildren && (
                        <div
                          id={`wf-collapse-${H1.id}`}
                          className='collapse'
                          data-parent='#H1Group'
                        >
                          <div className='w-100 accordion' id={`H2Group-${i}`}>
                            <ul className='navbar-nav p-3 H2Group'>
                              {H1.children.map((H2) => {
                                const H2HasContent = pageHasContent(H2.content);
                                const H2HasChildren = H2.children.length > 0;
                                return !H2HasChildren ? (
                                  <li
                                    key={H2.id}
                                    id={`wf-H2-${H2.id}`}
                                    className={`left-nav__container__item${renderActiveClasses(
                                      H2
                                    )}`}
                                  >
                                    <Link
                                      to={defineReference(H2)}
                                      onClick={() => handleSetPage(H2, true)}
                                      className='left-nav__container__item__link'
                                    >
                                      {isBookmark(H2.slug)}
                                      {H2.title}
                                    </Link>
                                  </li>
                                ) : (
                                  <li
                                    key={H2.id}
                                    id={`wf-H2-${H2.id}`}
                                    className='left-nav__container__h2_children'
                                  >
                                    <div className='left-nav__container__item'>
                                      <Link
                                        to={defineReference(H2)}
                                        onClick={() =>
                                          handleSetPage(H2, H2HasContent)
                                        }
                                        className={`left-nav__container__item__link${renderActiveClasses(
                                          H2
                                        )}`}
                                      >
                                        {isBookmark(H2.slug)}
                                        {H2.title}
                                      </Link>
                                      {renderLeftNavIcon(H2)}
                                    </div>
                                    <div
                                      id={`wf-collapse-${H2.id}`}
                                      className='collapse'
                                      data-parent={`#H2Group-${i}`}
                                    >
                                      <div className='w-100' id='H3Group'>
                                        <ul className='navbar-nav px-3 pb-3'>
                                          {H2.children &&
                                            H2.children.map((H3) => (
                                              <li
                                                key={H3.id}
                                                id={`wf-H3-${H3.id}`}
                                                className={`left-nav__container__child${renderActiveClasses(
                                                  H3
                                                )}`}
                                              >
                                                <Link
                                                  to={defineReference(H3)}
                                                  onClick={() =>
                                                    handleSetPage(H3, true)
                                                  }
                                                >
                                                  {isBookmark(H3.slug)}
                                                  {H3.title}
                                                </Link>
                                              </li>
                                            ))}
                                        </ul>
                                      </div>
                                    </div>
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                        </div>
                      )}
                    </li>
                  );
                })}
              </ul>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  navigation: state.document.currentDocument.navigation,
  currentPage: state.document.currentPage,
  isPreview: state.client.isPreview,
  document: state.document.currentDocument,
  bookmarks: state.user.bookmarks,
  user: state.user.user,
});

const mapDispatchToProps = { setCurrentPage, UpdateUserUsage };

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(LeftNav);
